import React from "react";
import C3Chart from "react-c3js";
import clientService from "../../../services/client";
import ChartDateRangeForm from "./ChartDateRangeForm";
import AnalyticsChartCard from "./AnalyticsChartCard";
import {
  defaultStartDate,
  timeToAnswerAxis,
  formatHourLabel,
  parseShiftHour,
  filterNonWorkingHours,
} from "./chartUtils";

const emptyChart = {
  x: "x",
  columns: [["x"], ["Total chats"]],
};

const DEFAULT_SHIFT_START = "09:00";
const DEFAULT_SHIFT_END = "20:00";

export default class ChatNonWorkingHoursChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: defaultStartDate(),
      endDate: new Date(),
      chartData: emptyChart,
    };
  }

  componentDidMount() {
    this.fetchData(this.state.startDate, this.state.endDate);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.shiftStartTime !== this.props.shiftStartTime ||
      prevProps.shiftEndTime !== this.props.shiftEndTime
    ) {
      this.fetchData(this.state.startDate, this.state.endDate);
    }
  }

  getShiftHours() {
    const startHour = parseShiftHour(
      this.props.shiftStartTime || DEFAULT_SHIFT_START,
      9,
    );
    const endHour = parseShiftHour(
      this.props.shiftEndTime || DEFAULT_SHIFT_END,
      20,
    );
    return { startHour, endHour };
  }

  async fetchData(startDate, endDate) {
    let chartData = emptyChart;
    const { startHour, endHour } = this.getShiftHours();
    try {
      const res = await clientService.getAnalyticsChatNonWorkingGraph(
        startDate,
        endDate,
      );
      console.log("Chat in non working hours response:", res);
      if (res.statusCode === 200 && res.data && res.data.length > 0) {
        const myData = filterNonWorkingHours(res.data, startHour, endHour);
        console.log("Chat in non working hours (shift):", {
          startHour,
          endHour,
          data: myData,
        });
        chartData = {
          x: "x",
          columns: [
            ["x", ...myData.map((m) => formatHourLabel(m.hour))],
            ["Total chats", ...myData.map((m) => m.count)],
          ],
        };
      }
      console.log("Chat in non working hours chart:", chartData);
    } catch (err) {
      console.error(err);
    }
    this.setState({ chartData });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.fetchData(this.state.startDate, this.state.endDate);
  };

  render() {
    return (
      <React.Fragment>
        <ChartDateRangeForm
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onStartChange={(date) => this.setState({ startDate: date })}
          onEndChange={(date) => this.setState({ endDate: date })}
          onSubmit={this.handleSubmit}
          layout="compact"
        />
        <AnalyticsChartCard
          title=" Chat in non working hours "
          cardClassName="box-3rd card card101"
        >
          <C3Chart
            size={{ height: 500 }}
            padding={{ left: 100, right: 50 }}
            data={this.state.chartData}
            legend={{ show: true }}
            axis={timeToAnswerAxis}
          />
        </AnalyticsChartCard>
      </React.Fragment>
    );
  }
}
